class distributor {

	constructor(originalArray, filteredArray, paginationLimit, paginationNumbersElement) {
		this.originalArray = originalArray;
		this.filteredArray = filteredArray;
		this.inputValuesArray = [];
		this.paginationLimit = paginationLimit;
		this.paginationNumbersElement = paginationNumbersElement;
        this.currentPage = 1;
        this.pageCount = 1;
		this.drawFilter();
		this.drawDistributorResults("country");
	}

	get originalArray() {
		return this._originalArray;
	}

	set originalArray(originalArray) {
		this._originalArray = originalArray;
	}

    get currentPage() {
        return this._currentPage;
    }
    set currentPage(currentPage) {
         this._currentPage = currentPage;
    }

    get pageCount() {
        return this._pageCount;
    }
    set pageCount(pageCount) {
         this._pageCount = pageCount;
    }

	appendPageNumber = (index, currentPage) => {
      const pageNumber = document.createElement("button");
      let activeClass = (index === Number(currentPage)) ? "active" : ""; 
      pageNumber.className = "pagination-number " + activeClass;
      pageNumber.innerHTML = index;
      pageNumber.setAttribute("page-index", index);
      pageNumber.setAttribute("aria-label", "Page " + index);

      this.paginationNumbersElement.appendChild(pageNumber);
    };

    drawPaginator = (pageCount, currentPage) => {
        this.paginationNumbersElement.innerHTML = "";
		for (let i = 1; i <= pageCount; i++) {
			this.appendPageNumber(i, currentPage);
		}
    };

    doPagination(array, currentPage) {
        const startIndex = (currentPage - 1) * this.paginationLimit;
        const endIndex = startIndex + this.paginationLimit;
        return array.slice(startIndex, endIndex);           
    }  

    createLinkTag (target, link, text ) {
      let aTag = document.createElement('a');
      aTag.setAttribute('href',link);
      if(target != '') {
        aTag.setAttribute('target',target);
      }
      aTag.innerText = text;
      return aTag;
    }

    

	drawFilter() {

      const detectDeviceType = () =>
    // Use a regular expression to test the userAgent string for common mobile device identifiers.
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ? 'Mobile' // If any of the identifiers are found, return 'Mobile'.
      : 'Desktop'; // Otherwise, return 'Desktop'.

		//const distributors_filter_array = Object.groupBy(this._originalArray, ({ continent }) => continent);
        
        const distributors_filter_array = this._originalArray.reduce((map, e) => ({
          ...map,
          [e.continent]: [...(map[e.continent] ?? []), e]
        }), {});

        const parent = document.querySelector("#filter");
        const isMobile = detectDeviceType();

        Object.entries(distributors_filter_array).forEach(([continent, value]) => {
            let detailRow = document.createElement("details");
            if( isMobile != 'Mobile') {
              detailRow.setAttribute("open","open");  
            }
            let detailSummary = document.createElement("summary");
            detailSummary.innerHTML = continent;
            detailRow.appendChild(detailSummary);
            //value = Object.groupBy(value, ({ country }) => country);

            value.sort(function(a, b) {
              return a.country.localeCompare(b.country);
            });

            value = value.reduce((map, e) => ({
              ...map,
              [e.country]: [...(map[e.country] ?? []), e]
            }), {});
                      
            var prevCountry = "";
            //value.forEach(function(countries) {
              Object.entries(value).forEach(( [countries, value]) => {

                if(prevCountry != countries){
                    let filterCountryRowContainer = document.createElement("div");
                    filterCountryRowContainer.classList.add("continent-row-container");
                    let filterCountryRow = document.createElement("input");
                    filterCountryRow.classList.add("continent-row");
                    filterCountryRow.setAttribute("data-field", "country")
                    filterCountryRow.setAttribute("data-value", countries)
                    filterCountryRow.setAttribute("id", countries)
                    filterCountryRow.setAttribute("name", "dist-country")
                    filterCountryRow.type = "checkbox";
                    let filterCountryLabel = document.createElement("label");
                    
                    filterCountryLabel.appendChild(filterCountryRow);
                    filterCountryLabel.innerHTML = countries;
                    filterCountryLabel.setAttribute("for", countries);
                    filterCountryRowContainer.appendChild(filterCountryRow);
                    filterCountryRowContainer.appendChild(filterCountryLabel);
                    detailRow.appendChild(filterCountryRowContainer);
                }
                prevCountry = countries
                
            })
            parent.appendChild(detailRow);
        })
    }


    drawDistributorResults = (filterby) => {     

        const parent = document.querySelector("#results");
        parent.innerHTML = "";
        const _this = this; // SAVE THE CLASS CURSOR HERE
  
        if(_this.inputValuesArray.length > 0) {
          	_this.filteredArray = _this._originalArray.filter(v => _this.inputValuesArray.includes(v[filterby]));     
        } else {
          	_this.filteredArray = _this._originalArray;     
        }    
        
        _this.pageCount = Math.ceil(_this.filteredArray.length / _this.paginationLimit);   
        this.drawPaginator(_this.pageCount, _this.currentPage);
        
		_this.filteredArray = _this.doPagination(_this.filteredArray,_this.currentPage);



        _this.filteredArray.sort(function(a, b) {
          return a.continent.localeCompare(b.continent);
        });

        
        _this.filteredArray.forEach(function(distItem) {
            let distCard = document.createElement("div");
            distCard.classList.add("distributor-card");
            
            let distCardContinent = document.createElement("div");
            distCardContinent.classList.add("distributor-card-continent");
            distCardContinent.innerHTML = distItem.continent;

            let distCardCompany = document.createElement("div");
            distCardCompany.classList.add("distributor-card-company");
            distCardCompany.innerHTML = distItem.company;

            let distCardAddress = document.createElement("div");
            distCardAddress.classList.add("distributor-card-address", "has-icon");
            distCardAddress.innerHTML = distItem.address;
            //distCardAddress.appendChild(_this.createLinkTag("_blank","https://www.google.com/maps/place/"+distItem.address,distItem.address));

            let distCardPhone = document.createElement("div");
            distCardPhone.classList.add("distributor-card-phone", "has-icon");
            //distCardPhone.innerHTML = distItem.telephone;
            distCardPhone.appendChild(_this.createLinkTag("","tel:"+distItem.telephone,distItem.telephone));

            let distCardEmail = document.createElement("div");
            distCardEmail.classList.add("distributor-card-email", "has-icon");
            //distCardEmail.innerHTML = distItem.email;
            distCardEmail.appendChild(_this.createLinkTag("","mailto:"+distItem.email,distItem.email));

            let distCardWebsite = document.createElement("div");
            distCardWebsite.classList.add("distributor-card-website", "has-icon");
            //distCardWebsite.innerHTML = distItem.website;
            distCardWebsite.appendChild(_this.createLinkTag("_blank","http://"+distItem.website,distItem.website));

            distCard.appendChild(distCardContinent);
            distCard.appendChild(distCardCompany);
            distCard.appendChild(distCardAddress);
            if(distItem.telephone) {
              distCard.appendChild(distCardPhone);  
            }
            if(distItem.email) {
              distCard.appendChild(distCardEmail);
            }
            if(distItem.website) {
              distCard.appendChild(distCardWebsite);
            }

            parent.appendChild(distCard);
            
        })
        
    }

	
} // END OF CLASS